import PropTypes from 'prop-types';
import {
  Container, Row, Col,
} from 'ui';
import ErrorComponent from 'ui/components/ErrorComponent';
import AuthPage from 'ui/layouts/AuthPage';

const ErrorPageLayout = ({
  title, subtitle, text,
}) => (
  <AuthPage>
    <Container>
      <Row>
        <Col lg={{ offset: 1, span: 10 }}>
          <ErrorComponent title={title} subtitle={subtitle} text={text} />
        </Col>
      </Row>
    </Container>
  </AuthPage>
);

ErrorPageLayout.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default ErrorPageLayout;
